<template>
  <el-select
    ref="baseSelect"
    class="base-select"
    :class="{ 'is-error': isError }"
    :popper-class="`base-select-dropdown ${popperClass}`"
    :size="size"
    :style="{ width }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="(slot, key) in $scopedSlots" :slot="key" slot-scope="scope">
      <slot :name="key" v-bind="scope"></slot>
    </template>
    <template v-for="(slot, key) in $slots" :slot="key">
      <slot :name="key"></slot>
    </template>
  </el-select>
</template>

<script>
export default {
  name: 'BaseSelect2',
  props: {
    size: {
      type: String,
      default: 'small'
    },
    width: {
      type: String,
      default: '200px'
    },
    popperClass: {
      type: String,
      default: ''
    },
    isError: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getRefs() {
      return this.$refs.baseSelect
    }
  }
}
</script>

<style lang="scss" scoped>

$--font-size-base: 14px;
$--input-border-color: #E1E1E1;

.base-select ::v-deep {
  .el-input {
    font-size: $--font-size-base;
  }
  .el-input__inner {
    padding-left:$--input-padding-left;
    border-color: $--input-border-color;
    border-radius: $--border-radius-base2;
    &:hover {
      border-color: $--input-border-color-hover;
    }
    &:focus {
      border-color: $--input-border-color-focus !important;
    }
  }
  .el-input.is-focus .el-input__inner {
    border-color: $--input-border-color;
  }
  .el-input.is-disabled .el-input__inner {
    color: $--input-color-disabled;
    border-color: $--input-border-color-disabled;
    background-color: $--input-background-color-disabled;
  }
}

.base-select.is-error ::v-deep {
  .el-input__inner {
    border-color: $--color-danger;
  }
}
</style>
<style lang="scss">
.base-select-dropdown {
  .el-select-dropdown__item {
    &.hover, &:hover {
      background-color: #F7FCFB;
    }
    &.selected {
      color: $--form-color-base;
    }
  }
}
</style>